import React from "react";
import { Stack, Text, depascalize, ensure } from "sprint-common-web";

import { ContentReferenceType } from "../../../../common/types/ContentReferenceType";

type ContentProps = {
    content?: string;
    versions?: string[];
    contentType?: ContentReferenceType;
    testId?: string;
};

export function renderContent<T extends ContentProps>(item?: T): JSX.Element {
    ensure(item);

    const { content, versions, contentType, testId } = item;

    return (
        <Stack tokens={{ childrenGap: 5 }} data-testId={testId}>
            {content && (
                <Text
                    variant="smallPlus"
                    value={content}
                    styles={{ root: { fontWeight: "bold" } }}
                    testId="content-title"
                />
            )}
            {versions?.map((version, key) => (
                <Text key={`${key}-${version}`} variant="smallPlus" value={version} testId={`version-${key}`} />
            ))}
            {contentType && (
                <Text
                    variant="smallPlus"
                    value={`Type: ${depascalize(ContentReferenceType[contentType])}`}
                    testId="content-type"
                />
            )}
        </Stack>
    );
}
